import Individual from '../../individual/models/Individual'

export default {
  namespaced: true,
  actions: {
    async register({ dispatch }, { payload }) {
      try {
        const parent = await this._vm.$axios.post(
          '/api/parents/signup',
          payload
        )
        dispatch('entities/parents/insert', { data: parent }, { root: true })
        return parent
      } catch (error) {
        throw error
      }
    },
    async login({ _dispatch }, { payload }) {
      try {
        const accessToken = await this._vm.$axios.post(
          '/api/parents/oauth/token',
          {
            username: payload.username,
            password: payload.password
          }
        )
        return accessToken
      } catch (error) {
        throw error
      }
    },
    async forgotPassword({ _dispatch }, { payload }) {
      try {
        await this._vm.$axios.post('/api/parents/forgot-password', payload)

        return true
      } catch (error) {
        throw error
      }
    },
    async resetPassword({ _dispatch }, { payload }) {
      try {
        await this._vm.$axios.post('/api/parents/reset-password', payload)

        return true
      } catch (error) {
        throw error
      }
    },
    async sendSupportEmail({ _dispatch }, { payload }) {
      try {
        let data = {
          question_type: payload.question_type,
          message: payload.message
        }
        await this._vm.$axios.post('/api/teachers/supports', data)

        return true
      } catch (error) {
        throw error
      }
    },
    async createChild({ _dispatch }, name) {
      try {
        await this._vm.$axios.post('/api/parents/children', {
          name
        })
        return true
      } catch (error) {
        throw error
      }
    },
    async getChildren({ _dispatch }) {
      try {
        const individuals = await this._vm.$axios.get('/api/parents/children')
        Individual.deleteAll()
        Individual.insertOrUpdate({ data: individuals }, { root: true })
      } catch (error) {
        throw error
      }
    },
    async deleteChildren({ _dispatch }, childId) {
      try {
        await this._vm.$axios.delete(`api/parents/children/${childId}`)
        Individual.delete(childId)
      } catch (error) {
        throw error
      }
    },
    async updateChildInfo({ _dispatch }, { payload }) {
      try {
        let data = {
          name: payload.name,
          id: payload.id
        }
        await this._vm.$axios.patch(`/api/parents/children/${payload.id}`, data)

        return true
      } catch (error) {
        throw error
      }
    },
    async switchToChild({ _dispatch }, childId) {
      try {
        const accessToken = await this._vm.$axios.post(
          `/api/parents/children/${childId}/accounts`
        )
        return accessToken
      } catch (error) {
        throw error
      }
    }
  }
}
